<template>
	<div>
    <van-field
      v-model="email"
      type="text"
      label="新邮箱"
      placeholder="请输入邮箱"
      :label-width="100"
    />
    <van-field
      center
      clearable
      v-model="code"
      label="验证码"
      placeholder="请输入验证码"
    >
      <van-button class="mybtn" @click="getCode" slot="button" type="primary" size="middle" plain>
        {{sendBtnText }}
      </van-button>
    </van-field>
    <div class="common_block">
      <van-button type="warning" block @click="postEmail">{{translate('submit_amount_options')}}</van-button>
    </div>
	</div>
</template>
<script>
	export default {
		name: 'personal_phone2',
		data() {
			return {
        oldEmail:this.$route.query.email,
				email:'',
        code:'',
        sendBtnText:'获取验证码',
        // 计时器对象
        timer: null,
        // 倒数60秒
        counter: 60,
        iscou:true
			}
		},
		mounted() {
			if (this.$route.query.token == "" || this.$route.query.token == undefined) {
				this.$router.replace('/nologin')
			}
		},
		methods: {
      getCode(){
        if(this.email==""){
          this.$dialog.alert({
						message: '请输入邮箱'
					})
          return;
        }
        if(this.validateEmail(this.email)==false){
          this.$dialog.alert({
						message: '请输入正确的邮箱'
					})
          return;
        }
        if(!this.iscou){
          return false;
        }
        this.iscou=false;
        this.countDown();
        this.$axios({
					method: 'post',
					url: 'account_account/changeEmailCode', 
					data: {
            token: this.$route.query.token,
            email:this.email
          }
				}).then ((res) => {
					if (res.success) {
            console.log(1)
					}else {
						this.$dialog.alert({
							message: res.error_text
						})
					}
				})
      },
      postEmail(){
        if(this.email==""){
          this.$dialog.alert({
						message: '请输入邮箱'
					})
          return;
        }
        if(this.validateEmail(this.email)==false){
          this.$dialog.alert({
						message: '请输入正确的邮箱'
					})
          return;
        }
        if(this.code==""){
          this.$dialog.alert({
						message: '请输入验证码'
					})
          return;
        }
        this.$axios({
					method: 'post',
					url: 'account_account/resetEmail', 
					data: {
            customer_id:this.$route.query.customer_id,
            token: this.$route.query.token,
            email:this.oldEmail,
            email_code:this.code,
            email_new:this.email

          }
				}).then ((res) => {
					if (res.success) {
            this.$dialog.alert({
							message: "邮箱修改成功，请重新登录"
						}).then(() => { 
              window.sessionStorage.clear()
              if (window.JsObject != null) {
                  window.JsObject.jslogout();
              } else if(window.webkit != null){
                  window.webkit.messageHandlers.jslogout.postMessage('')
              }
            })
					}else {
						this.$dialog.alert({
							message: res.error_text
						})
					}
				})
      },
			/**
       * 倒计时
       */
       countDown () {
        // 将setInterval()方法赋值给前面定义的timer计时器对象，等用clearInterval()方法时方便清空这个计时器对象
        this.timer = setInterval(() => {
          // 替换文本，用es6里面的``这个来创建字符串模板，让秒实时改变
          this.sendBtnText = `(${this.counter}秒)后重新发送`
          this.counter--
          if (this.counter < 0) {
            // 当计时小于零时，取消该计时器
            clearInterval(this.timer)
            this.counter=60;
            this.sendBtnText='获取验证码';
            this.iscou=true;
          }
        }, 1000)
      },
      
			validateEmail(email) {
					var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
					return emailRegex.test(email);
			}
		},
	}
</script>
<style scoped>
  .mybtn{
    border:none;
    color: rgb(255,140,0);
  }
</style>

